import "./B2BSeoLeadGeneration.module.css";
import Header from "@/reusable_sections/Header";
import B2bLeadHero from "./sections/B2bLeadHero";
import WhatIsB2bSeo from "./sections/WhatIsB2bSeo";
import Services from "./sections/Services";
import BuyerIntent from "./sections/BuyerIntent";
import SearchProcess from "./sections/SearchProcess";
import Foundations from "./sections/Foundations";
import Industries from "./sections/Industries";
import Workflow from "./sections/Workflow";
import IndependentConsultant from "./sections/IndependentConsultant";
import Clarity from "./sections/Clarity";
import AiBuyerResearch from "./sections/AiBuyerResearch";
import Expectations from "./sections/Expectations";
import SeoLeadMachineCTA from "./sections/SeoLeadMachineCTA";
import Footer from "@/reusable_sections/Footer";
export default function B2BSeoLeadGenerationPage() {
  return <div>
      <Header />
      <B2bLeadHero />
      <WhatIsB2bSeo />
      <Services />
      <BuyerIntent />
      <SearchProcess />
      <Foundations />
      <Industries />
      <Workflow />
      <IndependentConsultant />
      <Clarity />
      <AiBuyerResearch />
      <Expectations />
      <SeoLeadMachineCTA />
      <Footer />
    </div>;
}